import { useFindById, useFindByName } from '@/context/SelectComponent/Base';
import { useGetCrItemsAllSuspense } from '@/context/services/cr_items/CrItems.service';
import { CrItems } from 'ap-openapi';

export const useFindCrItems = () => {
  const items = useGetCrItemsAllSuspense();
  const findById = useFindById<CrItems, 'id', 'display_name'>(items, {
    key: 'id',
    return: 'display_name',
    defaultVal: '',
  });
  const findByName = useFindByName<CrItems, 'display_name', 'id'>(items, {
    key: 'display_name',
    return: 'id',
    defaultVal: '',
  });
  return {
    findCrItemsById: findById,
    findCrItemsByName: findByName,
  };
};
